import { SegmentedControl as MantineSegmentedControl, type SegmentedControlProps } from '@mantine/core';

/** Compact 2–N option switcher (e.g. mobile pane tabs). */
export function SegmentedControl(props: SegmentedControlProps) {
  return <MantineSegmentedControl radius="md" size="sm" fullWidth {...props} />;
}
